<script lang="ts">
	import { get } from 'svelte/store';
	import { createEventDispatcher } from 'svelte';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { deepCopy } from 'src/helpers/utilities';
	import { devices } from 'src/stores/lists/devices';
	import { macToID } from 'src/helpers/interface_helpers';
	//Design system components
	import { Button, Container, Modal, Alert } from '@Shelly/shelly-design-system';
	//Components
	import DeviceInList from 'src/components/Lists/Devices/DeviceInList.svelte';
	import VcNameSettings from './VCNameSettings.svelte';
	//Types
	import type { VirtualComponentInterface, VirtualComponentTypes } from 'src/types/VirtualComponents';

	export let component: VirtualComponentInterface;
	export let showModal: boolean;
	export let waitForResponse = false;

	let settingsError = false;
	let settings = deepCopy(component.config);

	const dispatcher = createEventDispatcher();
	const key = component.key;
	const type: VirtualComponentTypes = key.split(':')[0] as VirtualComponentTypes;
	const bthomeDevice = get(devices)[macToID(settings?.addr)];
</script>

<Modal
	{showModal}
	on:close={() => (showModal = false)}
	title={$format('bthome_component_modal_settings', {
		default: 'Sensor Settings',
	})}
	removeScrollPadding
>
	<svelte:fragment slot="content">
		<Container padding="scrollPaddings">
			<VcNameSettings additionalInputClass="pb-s" bind:settings label={key} />
			{#if bthomeDevice}
				<Alert
					type="info"
					class="mb-s"
					heading={$format('alert_heading_inclusion_device_is_already_present_title', {
						default: 'This device is already present in your account.',
					})}
				/>
				<DeviceInList device={bthomeDevice} />
				<!-- DO NOT REMOVE COMMENT: Padding references -->
				<div class="pb-s"></div>
			{/if}
		</Container>
	</svelte:fragment>
	<div class="d-flex justify-content-end" slot="footer">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={() => (showModal = false)}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			disabled={settingsError || waitForResponse}
			loading={waitForResponse}
			on:click={() => dispatcher('edit', { settings, type, key })}
		>
			{$format('button_save', { default: 'Save' })}
		</Button>
	</div>
</Modal>
